import React, { Dispatch, SetStateAction, startTransition, useCallback, useContext, useEffect, useRef, useState } from "react";
import "./Body.css"
import qBlack from "../../../image/logo/QBlack.webp"
import FilterBar from "./Filter/FilterBar"
import MainCorp from "./MainCorp/MainCorp"
import { Restaurant,Location } from "../../../components/types/types";
import { AppContext } from "../../../context/AppContext";
import { RestaurantContext } from "../../../context/RestaurantContext";
interface BodyInterface {
    listBase:Restaurant[],
    fetchResto:boolean,
    setLengthResto: Dispatch<SetStateAction<number>>,
    setShowAll: Dispatch<SetStateAction<number>>,
    distanceFilter:(distance:number) => void,
    cityLoad?:string,
    cityLoadBrut?:string,
}
const Body:React.FC<BodyInterface> = ({cityLoad='',cityLoadBrut='',listBase,distanceFilter,fetchResto,setLengthResto,setShowAll}) => {
    const {setShowFilterTel,showFilterTel} = useContext(AppContext)

    const isMobile = typeof window !== "undefined" && window.innerWidth <= 699;
    const [closeFilterSelect,setCloseFilterSelect] = useState(true)

    useEffect(() => {
        if (window.innerWidth <= 699) return;
        const filterBar = document.querySelector(".containerFilterBar") as HTMLDivElement;
        const bodyCorp = document.querySelector(".bodyCorp") as HTMLDivElement;

        if (!filterBar || !bodyCorp) return;
        let scheduled = false;
        const read = () => {
            const rect = bodyCorp.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            return { rect, windowHeight };
        };
        const write = ({ rect, windowHeight }: { rect: DOMRect; windowHeight: number }) => {
            if (rect.bottom - 120 <= windowHeight) {
            filterBar.style.position = "absolute";
            filterBar.style.bottom = "10em";
            filterBar.style.top = "initial";
            } else {
            filterBar.style.position = "fixed";
            filterBar.style.bottom = "2em";
            filterBar.style.removeProperty("top");
            }
        };
        const onScroll = () => {
        if (scheduled) return;
            scheduled = true;
            requestAnimationFrame(() => {
            scheduled = false;
            const data = read();
            write(data);
            });
        };
        requestAnimationFrame(() => {
            const data = read();
            write(data);
        });

        document.addEventListener("scroll", onScroll, { passive: true });
        window.addEventListener("resize", onScroll, { passive: true });

        return () => {
            document.removeEventListener("scroll", onScroll);
            window.removeEventListener("resize", onScroll);
        };
        
    }, []);

    const startX = React.useRef<number | null>(null);
    const startY = React.useRef<number | null>(null);
    const lastX  = React.useRef<number | null>(null);
    const lastY  = React.useRef<number | null>(null);
    
    const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
        startX.current = e.changedTouches[0].clientX;
        startY.current = e.changedTouches[0].clientY;
    };
    
    const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
        lastX.current = e.changedTouches[0].clientX;
        lastY.current = e.changedTouches[0].clientY;
    };
    
    const handleTouchEnd = () => {
        if (startX.current == null || lastX.current == null || startY.current == null || lastY.current == null) return;
        const deltaX = lastX.current - startX.current;
        const deltaY = lastY.current - startY.current;
        if (Math.abs(deltaX) > Math.abs(deltaY) && deltaX > 80) setShowFilterTel(true);
        startX.current = startY.current = lastX.current = lastY.current = null;
    };

    const bodyCorpRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (window.innerWidth > 700) return;
        else { 
            const top = bodyCorpRef.current?.offsetTop ?? 0;
            window.scrollTo({ top, behavior: "auto" });
        }
        
    },[showFilterTel])

    return (
        <div
            className="bodyCorp"
            id="bodyCorp"
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
            ref={bodyCorpRef}
        >
      
            <div className="shadowLeftBodyCorp"></div>
            <div className="shadowRightBodyCorp"></div>
            {(!isMobile || showFilterTel) &&<FilterBar closeFilterSelect={closeFilterSelect} setCloseFilterSelect={setCloseFilterSelect} setShowAll={setShowAll} distanceFitler={distanceFilter}/>}  

            {
                fetchResto ?
            
                <MainCorp cityLoad={cityLoad} cityLoadBrut={cityLoadBrut} setLengthResto={setLengthResto}  listBase={listBase} />
                :
                <div className="loading smallText">
                    <div>
                    <img src={qBlack} className="circle" decoding="async"  loading="lazy" alt="chargement"/>
                    Chargement
                    </div>
                </div>
                }

               
        </div>
    )
}

export default Body